import { IComponentOptions } from "angular";
import { RoleDetailComponentController } from "./controller";

export const vsComponentName = "roleDetail";

export const roleDetailComponentOptions: IComponentOptions = {
  controller: RoleDetailComponentController,
  controllerAs: "roleDetailComponentController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    role: "<",
  },
};
